import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AssessmentOverviewAdapter } from './sections/assessmentOverview/adapter'
import { CertPeriodRecapAdapter } from './sections/certPeriodRecap/adapter'
import { SkilledNeedsSectionAdapter } from './sections/skilledNeeds/adapter'
import { DischargePlanningAdapter } from './sections/dischargePlanning/adapter'
import { AuthorizationAdapter } from './sections/authorization/adapter'
import { PlanOfCareAdapter } from './sections/planOfCare/adapter'
import { VisitSchedulingAdapter } from './sections/visitScheduling/adapter'
import { MedicationsAdapter } from './sections/medications/adapter'
import { VitalsAdapter } from './sections/vitals/adapter'
import { MedicalBackgroundAdapter } from './sections/medicalBackground/adapter'
import { SupervisoryReviewAdapter } from './sections/supervisoryReview/adapter'
import { NarrativeSectionAdapter } from './sections/narrative/adapter'
import { FinalStepsAdapter } from './sections/finalSteps/adapter'
import { RecertFormData } from './types/RecertFormData'
import { ADLNeedsAdapter } from './sections/adlNeeds/adapter'
import { mutateFlatAnswers } from '../helpers'
import { AssessmentType } from '../../Clinical/Assessments/constants'
import { AdapterOptions, SectionAdapter } from '../adapters/types'
import { BaseAssessmentAdapter } from '../adapters/BaseAssessmentAdapter'
import { BaseSubsectionAdapter } from '../adapters/BaseSubsectionAdapter'

const RECERT_SECTION_ADAPTERS: (
  | BaseSubsectionAdapter<RecertFormData>
  | SectionAdapter<RecertFormData>
)[] = [
  new AssessmentOverviewAdapter(),
  new CertPeriodRecapAdapter(),
  new SkilledNeedsSectionAdapter(),
  new ADLNeedsAdapter(),
  new DischargePlanningAdapter(),
  new AuthorizationAdapter(),
  new PlanOfCareAdapter(),
  new VisitSchedulingAdapter(),
  new MedicationsAdapter(),
  new VitalsAdapter(),
  new MedicalBackgroundAdapter(),
  new SupervisoryReviewAdapter(),
  new NarrativeSectionAdapter(),
  new FinalStepsAdapter()
]

export class RecertAssessmentAdapter extends BaseAssessmentAdapter<RecertFormData> {
  readonly assessmentType = AssessmentType.RECERT

  protected flatAnswersToFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): RecertFormData {
    // For now, return basic conversion to maintain compatibility
    const formData: Partial<RecertFormData> = {}

    for (const adapter of RECERT_SECTION_ADAPTERS) {
      const sectionData = adapter.extractFormData(flatAnswers, options)
      Object.assign(formData, sectionData)
    }

    return formData as RecertFormData & Record<string, unknown>
  }

  protected formDataToFlatAnswers(
    formData: RecertFormData,
    currentFlatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Record<string, QuestionnaireResponseItem> {
    const allMutations: Array<{ linkId: string; value: unknown }> = []

    // Build mutations from all section adapters dynamically
    for (const adapter of RECERT_SECTION_ADAPTERS) {
      if (adapter instanceof BaseSubsectionAdapter) {
        adapter.setFormData(formData)
        allMutations.push(...adapter.buildFlatAnswers())
      } else if (adapter instanceof SectionAdapter) {
        allMutations.push(...adapter.buildFlatAnswers(formData))
      }
    }

    mutateFlatAnswers(currentFlatAnswers, allMutations)

    return currentFlatAnswers
  }
}
